import { render, staticRenderFns } from "./CoozzyChevronDownIcon.vue?vue&type=template&id=13169e35&scoped=true"
import script from "./CoozzyChevronDownIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyChevronDownIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyChevronDownIcon.vue?vue&type=style&index=0&id=13169e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13169e35",
  null
  
)

export default component.exports